import Vue from 'vue'

import DefaultLayout from './DefaultLayout.vue'
import PanelLayout from './PanelLayout.vue'

export const PANEL = 'panel'

Vue.component('layout-default', DefaultLayout)
Vue.component(`layout-${PANEL}`, PanelLayout)
